import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import useBem from '@indicia/use-bem';

import './HeaderNavigation.scss';

interface NavigationLinksProps {
  isMobile?: boolean;
}

const HeaderNavigation = ({ isMobile = false }: NavigationLinksProps) => {
  const { t } = useTranslation();
  const { bemClassName } = useBem('header-navigation-bar');

  const links = [
    {
      to: '/about-us',
      text: t('generic.menu.about-us'),
    },
    {
      to: '/gezondleventest',
      text: t('generic.menu.about-test'),
    },
    {
      to: '/faq',
      text: t('generic.menu.faq'),
    },
  ];

  if (isMobile) {
    return (
      <>
        {links.map(({ to, text }) => (
          <NavLink
            key={to}
            to={to}
            className={bemClassName('menu-item')}
          >
            {text}
          </NavLink>
        ))}
      </>
    );
  }

  return (
    <nav className={bemClassName()}>
      {links.map(({ to, text }) => (
        <NavLink
          key={to}
          to={to}
          className={bemClassName('menu-item')}
        >
          {text}
        </NavLink>
      ))}
    </nav>
  );
};

export default HeaderNavigation;
